import React, { useRef } from 'react';
import Resizer from '../Resizer';
import { isTouch } from '../../../../components/utils/browser';
import { useEditorContainerSize } from '../../../../components/Editor/Context';
import { useWidth } from '../../hooks/useWidth';
import viewerStyles from '../../Viewer/Viewer.scss';
const DaDeviation = ({ deviation, link, Renderer, onResizeEnd, extOptions, attrWidth, defaultWidth, alignment, editorDomRef })=>{
    const containerSize = useEditorContainerSize();
    const figureRef = useRef(null);
    const { width, maxWidth } = useWidth(attrWidth, defaultWidth, extOptions.smallMedia, alignment, containerSize !== null && containerSize !== void 0 ? containerSize : 0);
    return /*#__PURE__*/ React.createElement("figure", {
        className: viewerStyles['deviation-figure'],
        ref: figureRef,
        style: {
            width
        },
        "data-dadeviation": "true",
        "data-deviation": JSON.stringify(deviation)
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            maxHeight: '100%',
            pointerEvents: 'none'
        }
    }, /*#__PURE__*/ React.createElement(Renderer, {
        deviation: deviation,
        width: width,
        extOptions: extOptions,
        link: link
    })), !isTouch() && extOptions.canResize && /*#__PURE__*/ React.createElement(Resizer, {
        key: width,
        editorDom: editorDomRef.current,
        imageRef: figureRef,
        minWidth: 10,
        maxWidth: maxWidth,
        minHeight: 10,
        maxHeight: Infinity,
        keepRatio: true,
        onResizeEnd: onResizeEnd
    }));
};
DaDeviation.displayName = 'DaDeviation';
export default DaDeviation;

//# sourceMappingURL=DaDeviation.js.map